import { suppressKeyboardEventForInput } from 'components/AgGrid/utils';
import type { BimActKc2TotalItemData } from 'gql/graphql';
import { bimNumberFormatter } from 'pages/Project/BimProject/BimCommonComponents/WorkOrderPriceCellRenderers';

import type { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';

import { ActKc2TotalDetailsSmrCell } from '../components/ActKc2TotalDetailsSmrCell';
import { ActTotalDetailsNameCell } from '../components/ActTotalDetailsNameCell';
import { getBimActCellClass } from '../helpers';
import type { IActTotalDetailsProps } from '../types';

export const useBimActsKc2TotalDetailsColumns = ({
    setInputValueHandler,
    resetCalculatedHandler,
    updateLimitedHandler,
    setTotalInflationHandler,
    statusProject,
    actKC2Id,
    contractStatus,
    workOrderStatus,
    isVersion,
    isActionDisabled,
    isReadOnly,
    inflationCalcType,
    isCommitting,
}: IActTotalDetailsProps) => {
    const columns = useMemo<ColDef<BimActKc2TotalItemData>[]>(
        () => [
            {
                headerName: 'Наименование',
                field: 'name',
                flex: 2,
                minWidth: 500,
                spanHeaderHeight: true,
                cellRenderer: ActTotalDetailsNameCell,
                cellRendererParams: {
                    updateLimitedHandler,
                    setTotalInflationHandler,
                    actKC2Id,
                    contractStatus,
                    workOrderStatus,
                    statusProject,
                    isVersion,
                    isActionDisabled,
                    isReadOnly,
                    inflationCalcType,
                },
                cellClassRules: getBimActCellClass,
                equals: () => false,
            },
            {
                headerName: 'Общая стоимость, руб.',
                children: [
                    {
                        headerName: 'Всего СМР',
                        field: 'smrTotal',
                        flex: 1,
                        minWidth: 220,
                        spanHeaderHeight: true,
                        type: 'rightAligned',
                        cellRenderer: ActKc2TotalDetailsSmrCell,
                        cellRendererParams: {
                            setInputValueHandler,
                            resetCalculatedHandler,
                            actKC2Id,
                            contractStatus,
                            workOrderStatus,
                            statusProject,
                            isVersion,
                            isActionDisabled,
                            isReadOnly,
                            isCommitting,
                        },
                        valueFormatter: bimNumberFormatter(0),
                        suppressKeyboardEvent: suppressKeyboardEventForInput,
                        equals: () => false,
                    },
                    {
                        headerName: 'ОЗП',
                        field: 'ozp',
                        flex: 1,
                        minWidth: 220,
                        spanHeaderHeight: true,
                        type: 'rightAligned',
                        valueFormatter: bimNumberFormatter(0),
                    },
                    {
                        headerName: 'ЭММ',
                        field: 'emm',
                        flex: 1,
                        minWidth: 220,
                        spanHeaderHeight: true,
                        type: 'rightAligned',
                        valueFormatter: bimNumberFormatter(0),
                    },
                    {
                        headerName: 'В том числе',
                        field: 'zpm',
                        spanHeaderHeight: true,
                        children: [
                            {
                                headerName: 'ЗПМ',
                                field: 'zpm',
                                flex: 1,
                                minWidth: 220,
                                type: 'rightAligned',
                                valueFormatter: bimNumberFormatter(0),
                            },
                        ],
                        marryChildren: true,
                    },
                ],
                marryChildren: true,
            },
            {
                headerName: 'ТЗР, чел.час',
                field: 'tzr',
                spanHeaderHeight: true,
                type: 'rightAligned',
                valueFormatter: bimNumberFormatter(2),
            },
        ],
        [
            actKC2Id,
            contractStatus,
            inflationCalcType,
            isActionDisabled,
            isCommitting,
            isReadOnly,
            isVersion,
            resetCalculatedHandler,
            setInputValueHandler,
            setTotalInflationHandler,
            statusProject,
            updateLimitedHandler,
            workOrderStatus,
        ],
    );

    return {
        columns,
    };
};
